import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { InviteFormContainer } from '@/components/pages/Membership/Invite/InviteForm';

export const MembershipInvitePage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.membership.invite.title');

  return (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      hasHeaderDivider={true}
      breadcrumbItems={[{ label: title }]}
      containerType="normal"
    >
      <InviteFormContainer />
    </PageRootWrapper>
  );
};
